export enum BausteinnameEnum {
  BERUF = 'BERUF',
  VERKEHR = 'VERKEHR',
  WOHNEN = 'WOHNEN',
  PRIVAT = 'PRIVAT',
}
